import React, { useEffect, useState } from 'react'
import {
  Button,
  InputAdornment,
  makeStyles,
  TextField
} from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS } from 'asterX-UI'
import CheckBoxBtn from 'asterX-UI/Inputs/CheckBoxBtn'
import { KzIcon, LockedIcon, RuIcon } from 'asterX-UI/Icons'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { LANGUAGES } from 'constants/client'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Modal } from 'asterX-UI/Modals'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import ClientNeedsModal from 'pages/Desktop/Selection/Manager/components/ClientNeedsModal'
import ClientHistory from 'pages/Desktop/Selection/Manager/components/ClientHistory'
import CreateTaskComponent from 'components/Desktop/Tasks/CreateTaskComponent'
import { PAYMENT } from 'constants/deals'

const useStyles = makeStyles(theme => ({
  header: {
    padding: 4,
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600
  },
  rootDiv: {
    display: 'flex',
    gap: 32,
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  seoData: { width: '100%', display: 'flex', flexDirection: 'column', gap: 16 },
  cardDiv: {
    display: 'flex',
    padding: '24px 16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 20,
    borderRadius: 12,
    backgroundColor: BASE_COLORS.White
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center'
  },
  iconedCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  }
}))

const NewSeo = () => {
  const classes = useStyles()
  const {
    store: { seoClient, sale, seoLoading },
    funcs: {
      onChangeSeoClientFields,
      startSelection,
      clientRejected,
      reInviteClient,
      updateStatusTrack
    }
  } = useSelectionStore()
  const [openTask, setOpenTask] = useState(false)
  const [isNeedsOpen, setIsNeedsOpen] = useState(false)
  const handleClose = () => {
    setIsNeedsOpen(false)
  }
  const handleOpen = () => {
    setIsNeedsOpen(true)
    if (sale?.saleStatusTrack?.code !== '130') {
      updateStatusTrack(130)
    }
  }
  const lockAdornment = (
    <InputAdornment position="start">
      <LockedIcon />
    </InputAdornment>
  )

  useEffect(() => {
    if (sale?.saleStatusTrack?.code === '130') {
      setIsNeedsOpen(true)
    }
  }, [sale?.saleStatusTrack?.code])

  return isNeedsOpen ? (
    <ClientNeedsModal handleClose={handleClose} onSave={startSelection} />
  ) : (
    <PageContainerDesktop
      customHeader={<div className={classes.header}>Новый подбор</div>}
    >
      <LoaderBackdrop loading={seoLoading} />
      <div className={classes.rootDiv}>
        <div className={classes.seoData}>
          <div className={classes.cardDiv}>
            <TextField
              label={'Имя'}
              fullWidth
              required
              disabled
              value={seoClient?.firstName}
              InputProps={{
                endAdornment: lockAdornment
              }}
            />
            <TextField label={'Отчество'} fullWidth />
            <TextField
              label={'Телефон'}
              fullWidth
              required
              value={seoClient?.phoneNumber}
              disabled
              InputProps={{
                endAdornment: lockAdornment
              }}
            />
            <div
              className={classes.row}
              style={{
                marginTop: 20,
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <CheckBoxBtn
                checked={seoClient?.language === LANGUAGES[1].code}
                name={'language'}
                onClick={({ target }) =>
                  onChangeSeoClientFields({ [target.name]: LANGUAGES[1].code })
                }
              >
                <div className={classes.iconedCheckbox}>
                  <RuIcon />
                  Русский
                </div>
              </CheckBoxBtn>
              <CheckBoxBtn
                checked={seoClient?.language === LANGUAGES[0].code}
                name={'language'}
                onClick={({ target }) =>
                  onChangeSeoClientFields({ [target.name]: LANGUAGES[0].code })
                }
              >
                <div className={classes.iconedCheckbox}>
                  <KzIcon />
                  Қазақша
                </div>
              </CheckBoxBtn>
            </div>
          </div>
          <div className={classes.row}>
            <Button
              variant={'contained'}
              size={'small'}
              color={'primary'}
              fullWidth
              disabled={seoLoading}
              onClick={() => handleOpen()}
            >
              Начать подбор авто
            </Button>
          </div>
          <div className={classes.row}>
            <Button
              variant={'contained'}
              size={'small'}
              fullWidth
              disabled={seoLoading}
              onClick={() => setOpenTask(true)}
            >
              Клиент не пришел
            </Button>
            <Button
              variant={'contained'}
              size={'small'}
              disabled={seoLoading}
              fullWidth
              onClick={reInviteClient}
            >
              Пригласить еще раз
            </Button>
          </div>
        </div>
        <ClientHistory phone={seoClient?.phoneNumber} />
      </div>
      <Modal open={openTask} onClose={() => setOpenTask(false)} fullWidth>
        <CreateTaskComponent
          saleId={sale?.id}
          globalId={sale?.globalId}
          isPayment={sale?.saleStatus?.code === PAYMENT}
          client={{
            contactFullname: `${sale?.client?.firstName || ''} ${
              sale?.client?.lastName || ''
            }`,
            phoneNumber: sale?.client?.phoneNumber || '',
            additionalPhoneNumber: sale?.client?.additionalPhoneNumber || ''
          }}
          onClose={() => setOpenTask(false)}
          onSuccess={clientRejected}
        />
      </Modal>
    </PageContainerDesktop>
  )
}
export default NewSeo
